import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const K1_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-k-1',
          labelEn: 'Program Guide K-1',
          labelEs: 'Guía del programa K—1',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página web',
          filePath: 'assets/printables/en/K-1/Program_Guide_K-1.pdf',
          filePathEs: 'assets/printables/es/K-1/Program_Guide_K-1_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-k-1',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/K-1/Letter_Administrator_K-1.docx',
          filePathEs: 'assets/printables/es/K-1/Letter_Administrator_K-1_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Items',
      headingEs: 'Items',
      items: [
        {
          id: 'bills-1-k-1',
          labelEn: '$1 Bills',
          labelEs: 'Billetes de $1',
          filePath: 'assets/printables/en/K-1/Bills_1_K-1.pdf',
          filePathEs: 'assets/printables/es/K-1/Bills_1_K-1_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-k-1',
          labelEn: 'Job Posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/K-1/Job_Posters_K-1.pdf',
          filePathEs: 'assets/printables/es/K-1/Job_Posters_K-1_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'saver-cert-k-1',
          labelEn: 'Saver certificate',
          labelEs: 'Certificado de ahorro',
          filePath: 'assets/printables/en/K-1/Saver_Cert_K-1.pdf',
          filePathEs: 'assets/printables/es/K-1/Saver_Cert_K-1_ES.pdf',
          iconType: 'pdf'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash box or envelope', labelEs: 'Caja de dinero' },
      { labelEn: 'Items for store', labelEs: 'Artículos para la tienda' }
    ]
  }
};
